import LegalPage from '$lib/storyblok/pages/legalPage.svelte';
import { registerComponents } from '$lib/storyblok/sdk';

registerComponents({
	legal_page: LegalPage
});
